import { render, staticRenderFns } from "./hqglCarRegBorrowApproval.vue?vue&type=template&id=9378a24a&scoped=true&"
import script from "./hqglCarRegBorrowApproval.vue?vue&type=script&lang=js&"
export * from "./hqglCarRegBorrowApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9378a24a",
  null
  
)

export default component.exports